<template>
  <panel title="Informações gerais do produto">
    <div class="l-row">
      <form-group label="Título" :columns="12" slot="product" :error="getError('title', product.productId)" :required="true">
        <input class="form-input" type="text" v-model="product.title" :disabled="canChangeTitle()">
        <small class="form-help" v-bind:class="titleLength">{{ getTitleLengthLabel() }}</small>
      </form-group>

      <form-group label="Descrição" :columns="12" slot="product" :error="getError('description', product.productId)" :required="true">
        <textarea class="form-textarea" rows="8" :options="{ placeholder: 'Adicione a descrição do seu produto aqui' } " v-model="product.description"></textarea>
        <small class="form-help" v-bind:class="descriptionLength">{{ getDescriptionLengthLabel() }}</small>
      </form-group>
    </div>
  </panel>
</template>

<script>
import { mapGetters } from 'vuex'
import Panel from '@/components/template/Panel'
import FormGroup from '@/components/template/FormGroup'

export default {
  inject: ['maxDescriptionLengthDI', 'maxTitleLengthDI'],
  props: {
    product: {
      type: Object,
      required: true
    },
    identifier: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters('errors', [
      'getError'
    ]),
    descriptionLength () {
      return {
        't-success': this.product.description.length <= this.maxDescriptionLengthDI,
        't-error': this.product.description.length > this.maxDescriptionLengthDI
      }
    },
    titleLength () {
      return {
        't-success': this.product.title.length <= this.maxTitleLengthDI,
        't-error': this.product.title.length > this.maxTitleLengthDI
      }
    }
  },
  mounted () {
    this.removeHtml()
  },
  methods: {
    getDescriptionLengthLabel () {
      return `${this.product.description.length}/${this.maxDescriptionLengthDI}`
    },
    getTitleLengthLabel () {
      return `${this.product.title.length}/${this.maxTitleLengthDI}`
    },
    removeHtml () {
      const find = ['&Aacute;', '&aacute;', '&Acirc;', '&acirc;', '&Agrave;', '&agrave;', '&Aring;', '&aring;', '&Atilde;', '&atilde;', '&Auml;', '&auml;', '&AElig;', '&aelig;', '&Eacute;', '&eacute;', '&Ecirc;', '&ecirc;', '&Egrave;', '&egrave;', '&Euml;', '&euml;', '&ETH;', '&eth;', '&Iacute;', '&iacute;', '&Icirc;', '&icirc;', '&Igrave;', '&igrave;', '&Iuml;', '&iuml;', '&Oacute;', '&oacute;', '&Ocirc;', '&ocirc;', '&Ograve;', '&ograve;', '&Oslash;', '&oslash;', '&Otilde;', '&otilde;', '&Ouml;', '&ouml;', '&Uacute;', '&uacute;', '&Ucirc;', '&ucirc;', '&Ugrave;', '&ugrave;', '&Uuml;', '&uuml;', '&Ccedil;', '&ccedil;', '&Ntilde;', '&ntilde;', '&lt;', '&gt;', '&amp;', '&reg;;', '&copy;;', '&Yacute;', '&yacute;', '&THORN;', '&thorn;', '&szlig;', '&quot;', '&nbsp;']
      const replace = ['Á', 'á', 'Â', 'â', 'À', 'à', 'Å', 'å', 'Ã', 'ã', 'Ä', 'ä', 'Æ', 'æ', 'É', 'é', 'Ê', 'ê', 'È', 'è', 'Ë', 'ë', 'Ð', 'ð', 'Í', 'í', 'Î', 'î', 'Ì', 'ì', 'Ï', 'ï', 'Ó', 'ó', 'Ô', 'ô', 'Ò', 'ò', 'Ø', 'ø', 'Õ', 'õ', 'Ö', 'ö', 'Ú', 'ú', 'Û', 'û', 'Ù', 'ù', 'Ü', 'ü', 'Ç', 'ç', 'Ñ', 'ñ', '<', '>', '&', '®', '©', 'Ý', 'ý', 'Þ', 'þ', 'ß', '\\"', ' ']

      for (let i in find) {
        const f = find[i]
        this.product.description = this.product.description.replace(new RegExp(f, 'g'), replace[i])
      }

      this.product.description = this.product.description
        .replace(/<p>/g, '')
        .replace(/<\/p>|<br>|<br \/>|<br\/>/g, `\n`)
        .replace(/<li>\s*/g, '  • ')
        .replace(/<\/li>/g, '')
        .replace(/<ul[^>]*>/g, '')
        .replace(/<\/ul>/g, '')
        .replace(/(<([^>]+)>)/ig, '')
        .replace(/\n{3,}/g, '\n\n')
        .replace(/^\n+/, '')
    },
    canChangeTitle () {
      return this.identifier === 'mercadoLivre' && this.product.soldQuantity > 0
    }
  },
  watch: {
    'product.description' (value) {
      this.removeHtml()
    }
  },
  components: {
    Panel,
    FormGroup
  }
}
</script>



// WEBPACK FOOTER //
// Main.vue?98b8de7c